<h2 class="text-center"> Enrolment List</h2>
<div class="table-responsive" *ngIf="!loading">
  <table datatable  [dtOptions]="dtOptions" class="table table-striped display compact" id="assetTable">
    <thead>
    <tr>

        <th>Payment Order Id</th>
        <th>Guardian Names</th>
        <th>Email</th>
        <th>Student Names</th>

        <th>Start Date</th>
       <th>End Date</th>
       <th>Subscriptions</th>
       <th>Valid</th>
       <th>Current</th>
       <th>Premium</th>
       <th>Days</th>
    </tr>
    </thead>

    <tbody>

        <tr *ngFor="let enrolment of enrolments;">

        <td>{{enrolment.paymentOrderId}}</td>
        <td>{{enrolment.guardianNames}}</td>
        <td>{{enrolment.email}}</td>
        <td> <a [routerLink]="['/student/enrollments',enrolment.server_student_user_id]">{{enrolment.studentNames}}</a></td>

        <td>{{enrolment.startDate}}</td>
        <td>{{enrolment.endDate}}</td>
        <td>{{enrolment.subscriptionCount}}</td>
        <td>{{enrolment.isValid}}</td>
        <td>{{enrolment.isCurrent}}</td>
        <td>{{enrolment.isPremium}}</td>
        <td>{{enrolment.days}}</td>

    </tr>

    </tbody>

</table>
</div>
<app-empty [isEmpty]="isEmpty"></app-empty>
<app-loading [loading]="loading"></app-loading>

